module.exports = __webpack_public_path__ + "img/avatar_default_1.48793ae8.svg";